import merge from 'lodash/merge'
import objectFilter from '@converdy/utils/object-filter'
import { parseResponsiveProperty } from '../'

function parseTypography ({
  fontFamily,
  fontSize,
  fontWeight,
  fontSpacing,
  fontTransform,
  color,
  linkColor,
  linkHoverColor,
  lineHeight
}) {
  const jss = {}

  merge(jss, {
    ...merge( 
      parseResponsiveProperty('fontWeight', fontWeight),
      parseResponsiveProperty((v = {}) => {
        return v.unit && v.value ? {
          lineHeight: v.value + v.unit
        } : {} 
      }, lineHeight),
      parseResponsiveProperty((v = {}) => {
        return v.unit && v.value ? {
          fontSize: v.value + v.unit
        } : {} 
      }, fontSize),
      parseResponsiveProperty((v = {}) => {
        return v.unit && v.value ? {
          letterSpacing: v.value + v.unit
        } : {} 
      }, fontSpacing)
    ),
    textTransform: fontTransform,
    color,
    '& a': {
      color: linkColor
    },
    '& a:hover': {
      color: linkHoverColor
    },
  })

  

  if(fontFamily) {
    merge(jss, {
      fontFamily: `var(--font-${fontFamily})`,
    })
  }

  return  jss

}

export default parseTypography
